"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {find,findIn, findAllIn, on, closest} from '@elements/dom-utils';
import Collapse from 'bootstrap/js/dist/collapse';

let CollapseInit;

const selectors = {
    base: '.js-collapse-checkbox',
    checkbox: '.js-collapse-checkbox__checkbox',
    content: '.js-collapse-checkbox__content'
};

export function init () {

    onFind(selectors.base, function (baseElement) {
        let checkbox = findIn(selectors.checkbox, baseElement);
        let content = findIn(selectors.content, baseElement);
         
        console.log(content);

        CollapseInit = new Collapse(content, {
            toggle:false
        });

        toggleCollapse(checkbox, baseElement, false)

        const checkboxChangeHandler = (evt) => {
            let checkbox = evt.target;
            toggleCollapse(checkbox, baseElement, true)
        }

        on('change', (evt) => checkboxChangeHandler(evt), checkbox);
    });

}




function toggleCollapse(checkbox,form, reInitFormValidation){
    console.log(checkbox);
    if (checkbox.checked){
        CollapseInit.show();

        let optionalRequiredFields = findAllIn('.js-checkbox-collapse__optional-required',form);
        optionalRequiredFields.required = true;

        optionalRequiredFields.map((element) => {
            element.required = true;
        });
    } else{
        CollapseInit.hide();

        let optionalRequiredFields = findAllIn('.js-checkbox-collapse__optional-required',form);
        optionalRequiredFields.map((element) => {
            element.required = false;
        });
    }
}
